import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useGovEvaluationStart } from '@/module/GovEvaluation/model/GovEvaluationQuery';

import { Id, useAppNotification } from '@feature/utils';

interface StartGovEvaluationButtonProps {
  evaluationId: Id;
}

export function StartGovEvaluationButton({ evaluationId }: StartGovEvaluationButtonProps) {
  const notification = useAppNotification();
  const { mutate, isPending } = useGovEvaluationStart(evaluationId);
  const { t } = useTranslation();

  const onClick = () => {
    mutate(undefined, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <Button
      loading={isPending}
      size="xs"
      onClick={onClick}
    >
      {t('govEvaluation.startReporting')}
    </Button>
  );
}
